import { render, staticRenderFns } from "./RedirectionPage.vue?vue&type=template&id=7a8c6f86&"
import script from "./RedirectionPage.vue?vue&type=script&lang=js&"
export * from "./RedirectionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports